// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tk_a bib_b bib_bj","SubscribedPhotoblogs__link":"tk_b bib_a bib_r"};